// Champs partages (js/event-fields.js) : prix normalise, heure, lien billetterie.
// Resolu a l'appel, pas au chargement : l'ordre des <script defer> est
// garanti par les pages, mais un module charge hors page (harnais de
// test, page oubliee) capturerait sinon `undefined` definitivement.
var NBF = new Proxy({}, { get: function (_t, k) {
  var f = window.LAgendaFields;
  if (!f) throw new Error('js/event-fields.js doit etre charge avant ' + 'guides.js');
  return f[k];
} });
// guides.js — Hub /guides (Paris) et /<ville>/guides/. Compte les concerts de
// la ville et alimente les clusters. A Paris, les guides sont des pages
// statiques (generate_temporal_pages, generate_guide_pages) ; dans une autre
// ville, les memes adresses sous son nom (/lyon/concerts/ce-soir/) sont servies
// par guide-view.html (reecriture), qui filtre les dates de la ville. Les
// quartiers et l'index des guides par genre restent propres a Paris.
(function(){
'use strict';

const MOIS_FR = ['janvier','fevrier','mars','avril','mai','juin','juillet','aout','septembre','octobre','novembre','decembre'];
const MOIS_FR_ACCENT = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];

// Genres vedettes exposes en cluster 03. 5 max pour rester lisible.
// Les `key` doivent matcher exactement scrapers/genre_mapper.py ALLOWED_GENRES
// (accents inclus) — sinon le filtrage par e.genre retourne vide.
const FEATURED_GENRES = [
  { key:'Rock',             slug:'rock',           label:'Rock' },
  { key:'Jazz / Soul / Funk', slug:'jazz-soul-funk', label:'Jazz · Soul · Funk' },
  { key:'Électro',          slug:'electro',        label:'Électro' },
  { key:'Rap & Hip-Hop',    slug:'rap-hip-hop',    label:'Rap · Hip-Hop' },
  { key:'Pop & Variété',    slug:'pop-variete',    label:'Pop · Variété' },
];

// ---------- helpers ----------
// Date locale « AAAA-MM-JJ », celle de `e.date`. toISOString() rend la date
// UTC : en France, le minuit local d'un samedi y devient le vendredi, et le
// week-end comptait vendredi + samedi, la semaine dimanche → samedi.
function toISO(d){ return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; }
function parseDate(s){ const d = new Date(s + 'T00:00:00'); return isNaN(d) ? null : d; }
function startOfWeek(d){ const x = new Date(d); const day = (x.getDay() + 6) % 7; x.setDate(x.getDate() - day); x.setHours(0,0,0,0); return x; }
function addDays(d, n){ const x = new Date(d); x.setDate(x.getDate() + n); return x; }
function fmtInt(n){ return n.toLocaleString('fr-FR'); }

// Prix : detecte gratuit + extrait min en euros si dispo.
// Delegue au module partage : cette fonction existait en 8 exemplaires
// avec 3 comportements differents (audit DATA 2026-08-25).
function parsePrice(p, e){ return NBF.parsePrice(p, e); }

// Regroupe les venues par code postal (75001 -> 1, 75018 -> 18, 92000 -> null).
function arrFromPostal(postal){
  if (!postal || !postal.startsWith('75')) return null;
  const n = parseInt(postal.slice(2), 10);
  return (n >= 1 && n <= 20) ? n : null;
}
function arrSuffix(n){ return n === 1 ? 'er' : 'e'; }

// Mappe nom de venue -> arrondissement via VENUES_DATA.
function buildVenueArrMap(){
  const map = new Map();
  if (typeof VENUES_DATA === 'undefined') return map;
  VENUES_DATA.forEach(v => {
    const arr = arrFromPostal(v.postal);
    if (arr == null) return;
    (v.names || [v.dbName]).forEach(n => map.set(n, arr));
    map.set(v.dbName, arr);
  });
  return map;
}

function currentMonthSlug(){
  const d = new Date();
  return { slug: MOIS_FR[d.getMonth()] + '-' + d.getFullYear(), label: MOIS_FR_ACCENT[d.getMonth()] + ' ' + d.getFullYear() };
}

// ---------- main ----------
async function main(){
  const villes = window.LAgendaVilles;
  if (villes) await villes.ready;
  const ville = villes && villes.current();
  // Page de ville sans index des villes : ses compteurs, rendus au build,
  // restent (jamais ceux de Paris sous le nom d'une autre ville).
  if (!ville && villes && villes.metaVille && villes.metaVille !== 'paris') return;
  const enVille = !!(ville && ville.slug !== 'paris');
  // Paris : le fichier que lisent ses guides statiques, pour des compteurs
  // qui tombent juste ; ailleurs, les fichiers de la ville.
  const sources = enVille ? ville.sources : ['/data/events_upcoming.json'];
  const base = enVille ? `/${ville.slug}` : '';
  let events = [];
  try {
    events = villes && villes.fetchSources ? await villes.fetchSources(sources)
      : await fetch(sources[0]).then(r => { if (!r.ok) throw new Error(sources[0] + ' HTTP ' + r.status); return r.json(); });
    // Les guides d'une ville sont des pages guide-view.js, qui ne listent que
    // les concerts : le hub compte comme elles. (Les guides statiques de Paris
    // listent aussi spectacles et humour.)
    if (enVille) events = events.filter(e => e.category == null || e.category === 'concert');
  } catch (e) {
    console.warn('[guides] fetch failed', e);
    return;
  }
  if (enVille){
    document.querySelectorAll('.gr-card[href^="/concerts/"]').forEach(a => {
      a.setAttribute('href', base + a.getAttribute('href'));
    });
    const quartiers = document.getElementById('cluster-quartier');
    if (quartiers) quartiers.style.display = 'none';
  }

  const now = new Date();
  const todayISO = toISO(now);
  const weekStart = startOfWeek(now);
  const weekEnd = addDays(weekStart, 6);
  // Week-end = samedi + dimanche courants (ou prochains si on est deja dimanche soir)
  const saturday = addDays(weekStart, 5);
  const sunday = addDays(weekStart, 6);
  // Si on est apres dimanche (cas impossible avec startOfWeek(lundi)) on prend le we suivant
  const satISO = toISO(saturday);
  const sunISO = toISO(sunday);
  const weekStartISO = toISO(weekStart);
  const weekEndISO = toISO(weekEnd);

  // Filtre events futurs uniquement (date >= aujourd'hui)
  const future = events.filter(e => e.date && e.date >= todayISO);

  // --- cluster 1 : temporel ---
  const tonight = events.filter(e => e.date === todayISO);
  const thisWeekend = events.filter(e => e.date === satISO || e.date === sunISO);
  const thisWeek = events.filter(e => e.date >= weekStartISO && e.date <= weekEndISO);

  setCardMeta('[data-guide="tonight"]', tonight.length, venuesDetail(tonight));
  setCardMeta('[data-guide="weekend"]', thisWeekend.length, twoDaysDetail(saturday, sunday));
  setCardMeta('[data-guide="week"]', thisWeek.length, weekDetail(weekStart, weekEnd));

  // --- cluster 2 : budget ---
  let freeEvents = 0;
  let cheapEvents = 0;
  let cheapMin = Infinity;
  // NBF.parsePrice rend {value, label} : ni `free` ni `min` (lus ici jusqu'au
  // 2026-10-13, d'ou 0 gratuit et 0 pas cher sur toutes les villes). Gratuit =
  // valeur 0, pas cher = plancher connu de 15 € au plus.
  future.forEach(e => {
    const p = parsePrice(e.price, e);
    if (p.value === 0) freeEvents++;
    else if (p.value != null && p.value > 0 && p.value <= 15) {
      cheapEvents++;
      if (p.value < cheapMin) cheapMin = p.value;
    }
  });
  setCardMeta('[data-guide="free"]', freeEvents, 'gratuits ou libres');
  setCardMeta(
    '[data-guide="cheap"]',
    cheapEvents,
    cheapMin !== Infinity ? 'à partir de ' + Math.round(cheapMin) + ' €' : 'moins de 15 €'
  );

  // --- cluster 3 : edito ---
  const mo = currentMonthSlug();
  const monthStart = toISO(new Date(now.getFullYear(), now.getMonth(), 1));
  const monthEnd = toISO(new Date(now.getFullYear(), now.getMonth() + 1, 0));
  const monthEvents = events.filter(e => e.date >= monthStart && e.date <= monthEnd);

  // Top du mois (card XL)
  const xl = document.querySelector('[data-guide="top-month"]');
  if (xl) {
    xl.href = base + '/guide/meilleurs-concerts-' + mo.slug + '/';
    const kick = xl.querySelector('.period-top');
    const titleEm = xl.querySelector('.period-em');
    if (kick) kick.textContent = mo.label;
    if (titleEm) titleEm.textContent = mo.label;
    setCardMeta('[data-guide="top-month"]', monthEvents.length, 'tous genres · pré-sélection');
  }

  // Cards genre
  const genreHost = document.getElementById('gr-genres');
  if (genreHost) {
    const counts = new Map();
    monthEvents.forEach(e => {
      if (!e.genre) return;
      counts.set(e.genre, (counts.get(e.genre) || 0) + 1);
    });
    genreHost.innerHTML = FEATURED_GENRES.map(g => {
      const n = counts.get(g.key) || 0;
      const href = base + '/guide/meilleurs-concerts-' + g.slug + '-' + mo.slug + '/';
      return `<a class="gr-card" href="${href}" data-genre="${g.slug}">
        <span class="gr-kicker">Top ${mo.label}</span>
        <h3 class="gr-title">${escapeHtml(g.label)}</h3>
        <p class="gr-meta"><b class="n">${fmtInt(n)}</b> concerts <span class="sep">·</span> <span class="detail">ce mois-ci</span></p>
        <span class="gr-go">Voir la sélection →</span>
      </a>`;
    }).join('');
  }

  const allLink = document.querySelector('[data-guide="all-genre-guides"]');
  if (allLink){
    if (enVille) allLink.style.display = 'none';  // index des guides : Paris seulement
    else allLink.href = '/guide/';
  }

  // --- cluster 4 : arrondissement ---
  const venueArr = buildVenueArrMap();
  const arrCounts = new Map(); // arr -> { count, venues:Set }
  future.forEach(e => {
    const arr = venueArr.get(e.venue);
    if (!arr) return;
    if (!arrCounts.has(arr)) arrCounts.set(arr, { count:0, venues:new Set() });
    const entry = arrCounts.get(arr);
    entry.count++;
    entry.venues.add(e.venue);
  });

  const arrHost = document.getElementById('gr-arr');
  if (arrHost) {
    const sorted = [...arrCounts.entries()]
      .sort((a, b) => b[1].count - a[1].count)
      .filter(([, data]) => data.count >= 3);

    if (!sorted.length) {
      arrHost.innerHTML = '<p class="gr-empty">Pas encore assez de données par quartier. Reviens plus tard.</p>';
    } else {
      arrHost.innerHTML = sorted.map(([arr, data]) => {
        const venues = [...data.venues].slice(0, 2).map(displayVenueShort).join(' · ');
        return `<a class="gr-arr" href="/concerts/paris-${arr}e/" data-arr="${arr}">
          <span class="arr-num">${arr}<sup>${arrSuffix(arr)}</sup></span>
          <span class="arr-meta"><b>${fmtInt(data.count)}</b> concerts · ${data.venues.size} salle${data.venues.size > 1 ? 's' : ''}</span>
          <span class="arr-venues">${escapeHtml(venues)}</span>
        </a>`;
      }).join('');
    }
  }

  // footer stats
  const foot = document.getElementById('foot-stats');
  if (foot) {
    const venueSet = new Set(future.map(e => e.venue).filter(Boolean));
    foot.textContent = fmtInt(future.length) + ' concerts · ' + venueSet.size + ' salles';
  }
}

function setCardMeta(selector, count, detail){
  const el = document.querySelector(selector);
  if (!el) return;
  const n = el.querySelector('.gr-meta .n');
  const d = el.querySelector('.gr-meta .detail');
  if (n) n.textContent = fmtInt(count);
  if (d && detail) d.textContent = detail;
}

function venuesDetail(evs){
  const s = new Set(evs.map(e => e.venue).filter(Boolean));
  if (!s.size) return 'aucun ce soir';
  return s.size + ' salle' + (s.size > 1 ? 's' : '');
}

function weekDetail(start, end){
  const fmt = d => d.toLocaleDateString('fr-FR', { day:'numeric', month:'short' });
  return fmt(start) + ' → ' + fmt(end);
}
function twoDaysDetail(sat, sun){
  const fmt = d => d.toLocaleDateString('fr-FR', { weekday:'short', day:'numeric' });
  return fmt(sat) + ' + ' + fmt(sun);
}

function displayVenueShort(name){
  if (typeof VENUES_DATA === 'undefined') return name;
  const v = VENUES_DATA.find(x => (x.names || []).includes(name) || x.dbName === name);
  return v ? v.display : name;
}

function escapeHtml(s){
  return String(s).replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', main);
} else {
  main();
}
})();
